import React, { useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsHeatmap from "highcharts/modules/heatmap";

HighchartsHeatmap(Highcharts);

const TreemapComponent = (data) => {
  useEffect(() => {
    const legendLabels = document.querySelectorAll(
      ".highcharts-coloraxis-labels text"
    );
    for (let i = 0; i < legendLabels.length; i++) {
      legendLabels[i].style.fill = "#FFFFFF";
    }
  }, []);

  const options = {
    chart: {
      type: "treemap",
      color: "#FFFFFF",
      backgroundColor: "transparent",
      height: 640,
      width: 1000,
      events: {
        load: function() {
          this.container.querySelector(".highcharts-button-box").style.display =
            "none";
          this.container.querySelector(
            ".highcharts-button-symbol"
          ).style.display = "none";
          this.container.querySelector(".highcharts-title").style.display =
            "none";
        },
      },
    },
    plotOptions: {
      treemap: {
        layoutAlgorithm: "squarified",
      },
    },
    colorAxis: {
      min: 0,
      max: 5,
      reversed: true,
      minColor: "#E7F3FD",
      maxColor: "#6AA2DB",
      labels: {
        style: {
          color: "#FFFFFF",
        },
      },
    },
    legend: {
      align: "left",
      verticalAlign: "bottom",
      layout: "horizontal",
      rtl: true,
      // useHTML: true,
      symbolWidth: 400,
      labelFormatter: function() {
        return '<p style="width: 142px;height: 20px;text-align: left;font: normal normal normal 18px/20px Arial;letter-spacing: 0px;color: #FFFFFF;opacity: 1;">Importance Score</p>';
      },
    },
    tooltip: {
      formatter: function() {
        return (
          '<p style="width: 142px;height: 20px;text-align: left;font: normal normal normal 18px/20px Arial;letter-spacing: 0px;opacity: 1;">' +
          this.point.value +
          "</p>"
        );
      },
    },
    series: [
      {
        name: "Value",
        data: data && data.data ? data.data : "No Data",
        dataLabels: {
          enabled: true,
          color: "#000000",
          style: {
            fontSize: "18px",
            textOutline: 'none'
          },
        },
      },
    ],
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default TreemapComponent;
